<template>
  <div class="intermediary-main-page">
    <main-header :hasBanner="true" :type="'intermediary'"></main-header>
    <section class="main-center">
      <div class="index-page-top">
        <el-carousel class="car-box">
          <el-carousel-item v-for="(item, index) in lbList" :key="index">
            <a target="_blank" :href="item.url">
              <img class="car-img" :src="item.banner" alt="" />
            </a>
          </el-carousel-item>
        </el-carousel>
        <el-tabs v-model="activeName" class="tab-box">
          <el-tab-pane label="工作动态" name="first">
            <div
              class="tab-new-item"
              v-for="(item, index) in gzdt"
              :key="index"
            >
              <a target="_blank" :href="item.url">
                <div class="new-item-title">
                  <div class="new-item-lin">•</div>
                  <span>{{ item.title }}</span>
                </div>
                <div>{{ item.releaseTime }}</div>
              </a>
            </div>
          </el-tab-pane>
          <el-tab-pane label="山东要闻" name="second">
            <div
              class="tab-new-item"
              v-for="(item, index) in sdyw"
              :key="index"
            >
              <a target="_blank" :href="item.url">
                <div class="new-item-title">
                  <div class="new-item-lin">•</div>
                  <span>{{ item.title }}</span>
                </div>
                <div>{{ item.releaseTime }}</div>
              </a>
            </div>
          </el-tab-pane>
          <el-tab-pane label="聊城要闻" name="third">
            <div
              class="tab-new-item"
              v-for="(item, index) in lcyw"
              :key="index"
            >
              <a target="_blank" :href="item.url">
                <div class="new-item-title">
                  <div class="new-item-lin">•</div>
                  <span>{{ item.title }}</span>
                </div>
                <div>{{ item.releaseTime }}</div>
              </a>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>


      <div class="nav-list">
        <a
          @click="jump(item.url)"
          class="nav-item"
          v-for="(item, index) in navList"
          :key="index"
          :style="{ background: item.bgColor || '#2eb7e6' }"
        >
          <img :src="item.icon" alt="" />
          <span>{{ item.title }}</span>
        </a>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import { newList } from "@/assets/api/index";

export default {
  name: "Intermediary",
  components: {
    mainHeader,
    mainFooter,
  },

  data() {
    return {
      navList: [
        {
          title: "经纪机构公示",
          icon: require("@/assets/img/item_1.png"),
          bgColor: "#2eb7e6",
          url: "/company/list",
        },
        {
          title: "经纪从业人员公示",
          icon: require("@/assets/img/item_2.png"),
          bgColor: "#ffa44c",
          url: "/person/list",
        },
        {
          title: "网签地点分布",
          icon: require("@/assets/img/item_1.png"),
          bgColor: "#54c693",
          url: "/company/map",
        },
        {
          title: "经纪机构信用档案",
          icon: require("@/assets/img/item_3.png"),
          bgColor: "#fe6a6b",
          url: "/credit/list",
        },

        {
          title: "挂牌房源公示",
          icon: require("@/assets/img/item_4.png"),
          bgColor: "#54c693",
          url: "/resources/list",
        },
        {
          title: "累计销售",
          icon: require("@/assets/img/item_4.png"),
          bgColor: "#fe6a6b",
          url: "/resources/salesList",
        },
        {
          title: "机构良好信息",
          icon: require("@/assets/img/item_1.png"),
          bgColor: "#2eb7e6",
          url: "/company/good",
        },
          {
          title: "从业人员良好信息",
          icon: require("@/assets/img/item_5.png"),
          bgColor: "#aa88f4",
          url: "/person/good",
        },
      ],
      lbList: [
      
      ],
      activeName: "first",
      gzdt: [],
      sdyw: [],
      lcyw: [],
    };
  },
  computed: {},
  mounted() {
    this.getNew(4);
    this.getNew(1);
    this.getNew(2);
    this.getNew(3);
  },
  methods: {
    jump(url) {
      const jumpUrl = this.$router.resolve({ path: url });
      window.open(jumpUrl.href, "_blank");
    },
    async getNew(type) {
      const res = await newList({ type: type });
      if (res && res.data && res.data.code == 200) {
        const list = res.data.rows || [];
        if (type === 1) {
          this.gzdt = list;
        }

        if (type === 2) {
          this.sdyw = list;
        }
        if (type === 3) {
          this.lcyw = list;
        }
        if (type === 4) {
          this.lbList = list;
        }
      }
    },
  },
};
</script>

<style lang="less">
.intermediary-main-page {
  background: #fff;
  .index-page-top {
    width: 100%;
    padding: 10px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .car-box {
    width: 466px;
    height: 300px;
    flex-shrink: 0;
    .car-img {
      width: 466px;
      height: 300px;
      object-fit: cover;
      background: #EEE;
    }
  }
  .tab-box {
    width: 590px;
    .tab-new-item {
      width: 100%;
      height: 43px;
      a {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #000;

        .new-item-title {
          display: flex;
          align-items: center;
          .new-item-lin {
            padding-right: 5px;
            text-decoration: none;
            flex-shrink: 0;
          }
          span {
            width: 400px;

            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .el-tabs__item {
      line-height: 1;
      height: 28px;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__item.is-active {
      color: #b1191a;
      &:hover {
        color: #b1191a;
      }
    }
    .el-tabs__item:hover {
      color: #b1191a;
    }
    .el-tabs__active-bar {
      background-color: #b1191a;
    }
  }
  .nav-list {
    display: flex;
    flex-wrap: wrap;
    padding: 30px 0;
    box-sizing: border-box;
    .nav-item {
      width: 262px;
      height: 160px;
      border-radius: 3px;
      display: flex;
      margin-right: 30.5px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 18px;
      flex-direction: column;
      cursor: pointer;
      img {
        height: 50px;
        width: auto;
        margin-bottom: 20px;
      }
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}

</style>